import mustache from 'mustache';
import * as g from './globalvars';

export function initResponsiveTabs() {
  const details = document.querySelectorAll<HTMLDetailsElement>(`.${g.SELECTOR.TAB_BAR} > details`);
  const detailsselect = document.getElementById(g.SELECTOR.TAB_SELECTOR) as HTMLSelectElement;

  detailsselect.addEventListener("change", selectTab)

  details.forEach((detail: HTMLDetailsElement) => {
    detail.addEventListener("toggle", () => {
      if (detail.open) {
        detailsselect.nodeValue = detail.dataset.order as string;
      }
    })
  });

  new ResizeObserver(entries => {
    entries.forEach(element => {
      const summaries = element.target.querySelectorAll(`.${g.SELECTOR.TAB_BAR} > details > summary`) as NodeListOf<HTMLElement>;
      const offset1 = summaries[0].offsetTop;
      const offset2 = summaries[summaries.length - 1].offsetTop;


      if (offset1 == offset2) {
        element.target.classList.remove(g.SELECTOR.TAB_COMPACT);
      } else {
        element.target.classList.add(g.SELECTOR.TAB_COMPACT);
      }
    });
  }).observe(document.querySelector(`.${g.SELECTOR.TAB_CONTAINER}`) as HTMLElement);

  document.querySelectorAll(`.${g.SELECTOR.TAB_CONTAINER} .${g.SELECTOR.LIST}`).forEach(zone => {
    new ResizeObserver(zones => {
      zones.forEach(element => {
        const target = element.target as HTMLElement;
        const tabbar = target.closest(`.${g.SELECTOR.TAB_BAR}`) as HTMLDivElement;
        target.style.height = "100vh"
        target.style.height = tabbar.getBoundingClientRect().height + tabbar.offsetTop - target.offsetTop - 62  + "px"
      });
    }).observe(zone) 
  });
}

export function createDragHandle() {
  let draghandle: HTMLElement = document.createElement("div");
  draghandle.innerHTML = g.DRAGHANDLE_TEMPLATE;
  return draghandle.firstChild ? draghandle.firstChild : "";
}

function selectTab(e: Event) {
  let value = Number((e.target as HTMLInputElement).value);
  let details = document.querySelectorAll(`.${g.SELECTOR.TAB_BAR} > details`)[value];
  details.setAttribute("open", "1");
}

export function toggleDrop(e: DragEvent, dropOrigin: string) {
  document.querySelector(`.${g.SELECTOR.HOVER_DROP}`)?.classList.remove(`${g.SELECTOR.HOVER_DROP}`);

  if (e.target == undefined) return;

  let target = (e.target as HTMLElement).closest(`.${g.SELECTOR.ITEM}`);

  if(target == undefined) {
    target = (e.target as HTMLElement).closest(`.${g.SELECTOR.LIST}`)
  }
  if(target == undefined || target.querySelector(`#${dropOrigin}`)) {
    return;
  }

  let classlist = target.classList;

  if (classlist.contains(g.SELECTOR.HOVER_DROP)) {
    classlist.remove(g.SELECTOR.HOVER_DROP);
  }
  if ((classlist.contains(g.SELECTOR.LIST) || classlist.contains(g.SELECTOR.ITEM)) && target.id != dropOrigin) {
    classlist.add(g.SELECTOR.HOVER_DROP);
  } 
  if (target.id == dropOrigin) {
    e.dataTransfer!.dropEffect = "none";
  } else if ((e.target as HTMLElement).closest(`.${g.SELECTOR.ITEM}`)) {
    e.dataTransfer!.dropEffect = "copy";
  } else {
    e.dataTransfer!.dropEffect = "move";
  }
}

export function getOwnPosition(id: string): number {
  const element = document.getElementById(id) as HTMLElement;
  const siblings = element.parentElement?.children as HTMLCollection;
  return [...siblings].indexOf(element);
}

export function getPositionInList(id: string): number {
  const element = document.getElementById(id) as HTMLElement;
  const siblings = element.closest(`.${g.SELECTOR.LIST}`)?.querySelectorAll(`.${g.SELECTOR.ITEM}`) as NodeListOf<HTMLElement>;
  return [...siblings].indexOf(element);
}

export function getNextDropSibling(e: DragEvent): HTMLElement {
  let siblings = [...document.querySelectorAll(`#${g.SELECTOR.MERGELIST} .${g.SELECTOR.ITEM}:not(.${g.SELECTOR.ITEM_DRAGHANDLE_ACTIVE}`)];
  let nextSibling = siblings.find(sibling => {
    const rect = sibling.getBoundingClientRect();
    return e.clientY <= rect.top + rect.height / 2;
  });
  return nextSibling as HTMLElement;
}

export function loadItems(items: g.Lists) {
  const tabbar = document.querySelector(`.${g.SELECTOR.TAB_BAR}`) as HTMLElement;
  const mergelist = document.getElementById(g.SELECTOR.MERGELIST) as HTMLElement;
  const select = document.getElementById(g.SELECTOR.TAB_SELECTOR) as HTMLElement;
  tabbar.innerHTML = "";
  mergelist.innerHTML = "";
  select.innerHTML = "";

  items["merged"].forEach(item => {
    generateItem(g.SELECTOR.MERGELIST, g.getItem(item.id, true));
  });

  items["originlists"].forEach(list => {
    const details_element = document.createElement("details");
    const summary_element = document.createElement("summary");
    const indicator_element = document.createElement("span");

    const section_element = document.createElement("section");
    const mergeallbutton_element = document.createElement("button");
    const list_element = document.createElement("div");

    details_element.name = g.SELECTOR.TAB_NAME;
    details_element.id = list["id"];
    details_element.setAttribute("data-order", ""+tabbar.children.length);

    summary_element.innerHTML = list["name"];
    indicator_element.classList.add("indicator");
    summary_element.append(indicator_element);

    mergeallbutton_element.classList.add("moveall");
    mergeallbutton_element.innerHTML = g.SELECTOR.TEXT_BUTTON_MOVEALL;

    const list_id = list["id"] + "-list";
    list_element.id = list_id;
    list_element.classList.add(g.SELECTOR.LIST);

    section_element.append(mergeallbutton_element);
    section_element.append(list_element);

    const option_element = document.createElement("option");
    option_element.value = ""+(tabbar.children.length );
    option_element.innerText = list["name"] + " ()";
    select.append(option_element);

    details_element.append(summary_element);
    details_element.append(section_element);
    tabbar.append(details_element);

    list["items"].forEach(item => {
      if ((item["mergedinto"] != undefined && item["mergedinto"].length > 0) || item["images"]) {
        item = g.getItem(item.id, true);
      }
      generateItem(list_id, item);
    });
  });
  tabbar.children[0].setAttribute("open", "1");
}

export function generateItem(parent_id: string, item: g.ListItem): HTMLElement {
  const parent_element = document.getElementById(parent_id) as HTMLElement;
  const element = document.createElement("details");
  
  element.id = item["id"];
  element.innerHTML = item["title"];
  element.draggable = true;
  element.classList.add(g.SELECTOR.ITEM);
  element.dataset.status = item["status"];
  
  var output = mustache.render(g.ITEM_TEMPLATE, item);
  element.innerHTML = output;
  element.setAttribute("data-role", g.SELECTOR.ITEM);

  const summary = element.querySelector("summary");

  if (summary != undefined) {
    summary.draggable = true;
    element.draggable = false;
  }

  if(parent_id != "") {
    parent_element.append(element);
  }
  
  return element;
}

export function updateItem(id: string, slice = true) {
  if(slice) {
    id = id.startsWith(g.SELECTOR.PREFIX_MOVED) ? id.slice(g.SELECTOR.PREFIX_MOVED.length) : id;
  }

  const element = document.getElementById(id) as HTMLElement;
  const moved_element = document.getElementById(g.SELECTOR.PREFIX_MOVED + id);

  const item = g.getItem(id, true);
  const output = mustache.render(g.ITEM_TEMPLATE, item);
  element.innerHTML = output;
  element.dataset.status = item["status"];

  const summary = element.querySelector("summary");

  if (summary != undefined) {
    summary.draggable = true;
    element.draggable = false;
  }

  if(moved_element != undefined) {
    moved_element.innerHTML = output;
    moved_element.querySelector("summary")?.append(createDragHandle());
  }
}

export function prepareModal(item_id: string): string {
  return mustache.render(g.DIALOG_TEMPLATE, g.getItem(item_id, true));
}

export function prepareEditModal(action: string, item_id = "") {
  const item = item_id == "" ? {} : g.getItem(item_id);
  item["action"] = action;
  let container = document.createElement("div");
  container.innerHTML = mustache.render(g.EDIT_TEMPLATE, item);
  container.querySelectorAll("select").forEach(select => {
    select.value = item[select.name];
  });
  return container;
}

export function arrange(id: string, position: number) {
  const element = document.getElementById(id) as HTMLElement;
  const parent = element.parentElement as HTMLElement;
  const children = [...parent.children];

  if(position == children.length - 1) {
    parent.append(element);
    return;
  } 

  let neighbour = children[position];
  parent.insertBefore(element, neighbour);
}

export function updateAllIndicators() {
  updateOriginIndicators();
  updateMergeIndicator();
}

function updateMergeIndicator() {
  const list_container = document.querySelector(`.${g.SELECTOR.MERGELIST_CONTAINER}`) as HTMLElement;
  const count = list_container.querySelector(`.${g.SELECTOR.LIST}`)?.children.length as number;
  const indicator_element = list_container.querySelector(".indicator") as HTMLElement;
  indicator_element.innerHTML = count.toString();
}

function updateOriginIndicators() {
  document.querySelectorAll<HTMLDetailsElement>(`.${g.SELECTOR.TAB_BAR} > details`).forEach((element) => {
    const count_total = element.querySelector(`.${g.SELECTOR.LIST}`)?.children.length;
    const count_added = element.querySelectorAll(`.${g.SELECTOR.LIST} [data-status='moved']`).length;
    const count_merged = element.querySelectorAll(`.${g.SELECTOR.LIST} [data-status='merged']`).length;

    const moveall_element = element.querySelector(`.${g.SELECTOR.BUTTON_MOVEALL}`) as HTMLButtonElement;
    const indicator_element = element.querySelector(".indicator") as HTMLElement;
    const option_indicator_element = document.querySelector(`#${g.SELECTOR.TAB_SELECTOR} option[value='${element.dataset.order}']`) as HTMLElement;

    moveall_element.disabled = count_added + count_merged == count_total; 

    const indicator_content = `${count_added + count_merged}/${count_total}`;
    indicator_element.innerHTML = indicator_content;

    let option_text = option_indicator_element.innerHTML;
    let option_text_arr = option_text.split("(");
    option_text_arr[option_text_arr.length - 1] = indicator_content;
    option_text = option_text_arr.join("(") + ")";
    option_indicator_element.innerHTML = option_text;
  });
}

export function hashUpdate(open = false) {
  const id = location.hash.substring(1);
  if (!id) return;

  const element = document.getElementById(id);
  if (!element) return;

  if (element instanceof HTMLDetailsElement && open) {
    element.open = true;
  }

  const tab = element.closest("[name='tabs']") as HTMLDetailsElement;
  if (tab) {
    const tab_select = document.getElementById(g.SELECTOR.TAB_SELECTOR) as HTMLSelectElement
    tab_select.value = tab.dataset.order as string;
  }
}

export function setHash(id: string) {
  window.history.replaceState(null, "", '#' + id);
  hashUpdate();
}
